<template>
    <van-row>
        <van-col span="21">
            <van-notice-bar @click="openNoticePopup" class="notice_container"
                :style="{ background: newsBarStyle.background_color }" :color="newsBarStyle.font_color" :text="newsText"
                speed="50">
                <template #left-icon>
                    <img :src="letIconImage" alt="">
                </template>
                <template #right-icon>
                    <van-badge v-if="unreadMsgCount > 0" :content="unreadMsgCount">
                        <div class="bell_img" :style="{ background: newsBarStyle.icon_color }">
                            <img src="@/assets/home/home_email_2.png" alt="" @click="goToMessage">
                        </div>
                    </van-badge>
                    <div v-else class="bell_img" :style="{ background: newsBarStyle.icon_color }">
                        <img src="@/assets/home/home_email_2.png" alt="" @click="goToMessage">
                    </div>
                </template>
            </van-notice-bar>
        </van-col>
        <van-col span="3">
            <div class="searchBtn" :style="{ background: newsBarStyle.background_color }" @click="openGameSearchPopup">
                <img src="@/assets/themetwo/icon_search.png" alt="">
            </div>
        </van-col>
    </van-row>
    <GamesearchPopup ref="gameSearchPopRef"/>
    <NoticePopup ref="NoticePopupRef" />
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router';
import NoticePopup from './noticePopup.vue';
import { useUserStore } from '@/stores/user';
import { openPopup, safeNavigate } from '@/view/home/supportScript';
import GamesearchPopup from './gamesearchPopup.vue';

const userStore = useUserStore()
const router = useRouter()
const newsBarStyle = ref(
    {
        background_color: "",
        font_color: "",
        icon_color: ""
    }
)
const letIconImage = ref()
const NoticePopupRef = ref();
const gameSearchPopRef = ref()
const props = defineProps<{
    itemData: {
        text: string | Record<string, string>,
        styles: {
            background_color: "",
            font_color: "",
            icon_color: ""
        },
        leftIcon_url: ''
    }
}>()
const unreadMsgCount = computed(() => userStore.unreadCount)
const emits = defineEmits(['goToGameSearch'])

const newsText = computed(() => {
    const text = props.itemData.text
    if (typeof text === 'string') return text
    const lang = localStorage.getItem('lang') || 'en'
    return text[lang] || text['en'] || ''
})

const openNoticePopup = () => {
    openPopup(NoticePopupRef)
}
const goToMessage = (event: Event) => {
    safeNavigate(router, '/sd-message', event)
}
const openGameSearchPopup = () => {
    // openPopup(gameSearchPopRef)
    emits('goToGameSearch')
}
onMounted(() => {
    newsBarStyle.value.background_color = props.itemData.styles.background_color
    newsBarStyle.value.font_color = props.itemData.styles.font_color
    newsBarStyle.value.icon_color = props.itemData.styles.icon_color
    letIconImage.value = props.itemData.leftIcon_url
})
</script>
<style scoped>
.notice_container {
    border-radius: 9px;
    font-size: 13px;
    height: 35px;
    padding: 5px 10px;
    margin-top: 5px;
}

.notice_container img {
    width: 18px;
    height: 18px;
    padding-right: 5px;
}

.bell_img {
    /* background: #f0a853; */
    display: flex;
    align-items: center;
    border-radius: 30px;
    justify-content: center;
    margin-left: 10px;
}

.bell_img img {
    width: 18px;
    padding: 2.5px
}

.notice_container>>>.van-badge {
    border: none;
}

.searchBtn {
    border-radius: 10px;
    height: 35px;
    padding: 5px 0px;
    margin-top: 5px;
    margin-left: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.searchBtn img {
   width: 50%;

}
</style>